import { createAction, props } from '@ngrx/store';

import { BAC_ACTION_PREFIX } from '../constants';

export const setIsCustomerAction = createAction(
  `${BAC_ACTION_PREFIX} Set isCustomer`,
  props<{ isCustomer: boolean }>()
);
